import { EfsMelcoEfsModelsSchemaListItem } from "melco-shared-logic";

const isVisible = (item: EfsMelcoEfsModelsSchemaListItem) => !!item.show;

export const useDataSourceSelect = (
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[]
) => {
  return dataAssignments.filter(isVisible).map(({ id, display_name }) => {
    return {
      label: display_name ?? "",
      value: id ?? "",
    };
  });
};
